// Coin news widget. No inner header — coin picker lives in the
// WidgetFrame header via NewsHeader. Body is just the news list.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useWidgetSetting } from '../cockpitContext.jsx';
import { useSharedCoinNews } from '../data/sharedCoinNews';
import { VirtualList, NewsRow } from '../../CoinTerminalSections/sectionHelpers';
import CoinPickerHeader from './CoinPickerHeader';

function NewsWidgetInstance({ instanceId, defaultCoin }) {
  const { t } = useTranslation();
  const [coin] = useWidgetSetting(instanceId, 'coin', defaultCoin);
  const { news } = useSharedCoinNews(coin);

  if (!news || news.length === 0) {
    return <div className="ct-section-content"><div className="ct-empty">{t('chartPage.empty.news', 'No news available')}</div></div>;
  }
  return (
    <VirtualList
      items={news.slice(0, 30)}
      rowHeight={64}
      getKey={(item, i) => item.guid || `${item.source}:${item.pubDate || i}`}
      renderRow={(item) => <NewsRow item={item} />}
    />
  );
}

// News widget only needs the coin picker in its header — no sort/filter
// controls. Kept as a separate named export to match the {body, headerExtras}
// pattern used by the other list widgets.
export { default as NewsHeader } from './CoinPickerHeader';

export default React.memo(NewsWidgetInstance);
